var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms d-flex"},[_c('Right',{attrs:{"chat":_vm.chat}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }